import axios from 'axios';
import router from '@/router';

import {Notification} from 'element-ui';
import {getToken} from '@/utils/auth';

import config from '@/config'

// ------- start -------------
let showErrMsg = (data) => {
  const maxChineseChars = 18; // 每行最大汉字数
  const lines = [];
  let currentLine = '';
  let currentLineLength = 0; // 当前行的长度（按字符宽度计算）

  for (const char of data.content) {
    let charWidth = 0;

    // 检测字符类型
    if (/[\u4e00-\u9fa5]/.test(char)) {
      charWidth = 2; // 汉字宽度为2
    } else if (/[a-zA-Z0-9]/.test(char)) {
      charWidth = 1; // 英文字符宽度为1
    } else {
      charWidth = 1; // 其他字符按英文字符处理
    }

    // 判断是否需要换行
    if (currentLineLength + charWidth > maxChineseChars * 2) {
      lines.push(currentLine);
      currentLine = char;
      currentLineLength = charWidth;
    } else {
      currentLine += char;
      currentLineLength += charWidth;
    }
  }

  // 添加最后一行
  if (currentLine) {
    lines.push(currentLine);
  }

  // 将换行后的内容拼接为 HTML
  const content = lines.join('<br>');
  Notification({
    title: data.title || '提示',
    message: content,
    type: data.type || 'warning',
    dangerouslyUseHTMLString: true, // 允许使用 HTML 内容
  });
};

let tokenErr = () => {
  router.push('/login').then();
  // showErrMsg({
  //   title: '提示',
  //   content: '登录令牌失效,请先登录',
  // });
};

// ------- end -------------

// 创建axios实例
const myAxiosInstance = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: config.apiHost,
  // 超时
  timeout: 20000,
});

myAxiosInstance.interceptors.request.use(
  (requestConfig) => {
    // requestConfig.baseURL = getBaseUrl()

    // let token = getToken()
    // if (token) {

    // if (!requestConfig.url.includes('accountLogin')) {
    requestConfig.headers['Authorization'] = 'Bearer' + ' ' + getToken();
    // }

    // }
    // 如果请求是 POST 方法，封装请求参数到 data 对象中

    let excelFileFlag = requestConfig.url.includes('/excel/device/importDeviceExcel');
    if (requestConfig.method.toLowerCase() === 'post' && !excelFileFlag) {
      // 如果请求体已经存在，将其封装到 data 对象中
      if (requestConfig.data) {
        requestConfig.data = {data: requestConfig.data};
      } else if (excelFileFlag) {
        // requestConfig.data = requestConfig.data;
      } else {
        // 如果没有请求体，初始化为空对象
        requestConfig.data = {data: {}};
      }
    }
    //数据导出
    if (requestConfig.data && requestConfig.data['exportExcel'] === true) {
      requestConfig.responseType = 'blob';
    }

    // return requestConfig; 或 return Promise.resolve(requestConfig);
    return Promise.resolve(requestConfig);
  },
  (err) => {
    showErrMsg({
      title: '提示',
      content: '请求异常',
    });
    return Promise.reject(err);
  }
);

myAxiosInstance.interceptors.response.use(
  (response) => {
    if (response.status < 500) {
      let res = response.data;
      // response.headers['xzd-code'] * 1 ||
      let code = res.code;
      let msg = decodeURIComponent(response.headers['xzd-msg'] || '') || res.msg;
      // let fileName = response.headers['xzd-file-name'] || '';

      if (response.config.url.includes('excel/deviceBatch/exportDeviceInfo')) {
        return response.data;
      }
      if (code + '' === '2000') {
        // && response.config.data.includes('"exportExcel":true') && fileName
        if (response.config.data) {
          return response.data;
        } else {
          return response.data;
        }
      } else if (code >= 1000 && code <= 1999) {
        showErrMsg({
          title: '提示',
          content: msg || '系统错误',
        });
        return Promise.reject(res);
      } else if (code >= 4000 && code <= 4999) {
        tokenErr();
        return Promise.reject(res);
      } else if (code >= 9000 && code <= 9999) {
        showErrMsg({
          title: '提示',
          content: msg || '系统错误',
        });
        return Promise.reject(res);
      } else {
        showErrMsg({
          title: '提示',
          content: '提示 res.code 未在预期内',
        });
        return Promise.reject('服务器异常');
      }
    } else {
      showErrMsg({
        title: '提示',
        content: '响应异常',
      });
    }
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      tokenErr();
    } else {
      showErrMsg({
        title: '提示',
        content: '服务器响应异常',
      });
    }

    return Promise.reject(error);
  }
);

export default myAxiosInstance;
